import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import settingsSprite from 'assets/icons/settings.svg';
import SettingsList from './SettingsList/index';
import {
  SettingsBarStyled,
  List,
  ListsWrap,
  ListWrap,
  StyledButton,
} from './styles/SettingsBarStyled';

class SettingsBar extends PureComponent {
  constructor(props) {
    super(props);

    props.closePopup(() => this.setState({ listDisplay: false }));
    props.getPopupState(() => this.state.listDisplay);

    this.state = {
      listOptionDisplay: '',
      listDisplay: false,
      checkListItem: '',
      audioTrackList: props.audioTrackList,
      subtitlesList: props.subtitlesList,
      qualityList: props.qualityList,
      qualityTransformFunc: ({ bitrate, name }) => ({
        value: bitrate,
        title: bitrate === -1 ? props.translate('embed.auto') : name,
      }),
      subtitlesTransformFunc: ({ lang_tag: langTag, display_name: displayName }) => ({
        value: langTag,
        title: displayName === 'off' ? props.translate('embed.off') : displayName,
      }),
      audioTransformFunc: ({ id, display_name: displayName }) => ({
        value: id,
        title: displayName,
      }),
    };

    this.state = {
      ...this.state,
      audioOptions: _.map(props.audioTrackList, this.state.audioTransformFunc),
      subtitlesOptions: _.map(props.subtitlesList, this.state.subtitlesTransformFunc),
      qualityOptions: _.map(props.qualityList, this.state.qualityTransformFunc),
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = {};
    if (!_.isEqual(nextProps.audioTrackList, prevState.audioTrackList)) {
      newState.audioOptions = _.map(nextProps.audioTrackList, prevState.audioTransformFunc);
      newState.audioTrackList = nextProps.audioTrackList;
    }
    if (!_.isEqual(nextProps.subtitlesList, prevState.subtitlesList)) {
      newState.subtitlesOptions = _.map(nextProps.subtitlesList, prevState.subtitlesTransformFunc);
      newState.subtitlesList = nextProps.subtitlesList;
    }
    if (!_.isEqual(nextProps.qualityList, prevState.qualityList)) {
      newState.qualityOptions = _.map(nextProps.qualityList, prevState.qualityTransformFunc);
      newState.qualityList = nextProps.qualityList;
    }
    if (_.isEmpty(newState)) {
      newState = null;
    }
    return newState;
  }

  onToggleDisplayList = () => {
    this.setState((prevState) => ({
      listDisplay: !prevState.listDisplay,
      listOptionDisplay: '',
    }));
  };

  onChangeDisplayListOption = (name) => {
    this.setState({
      listOptionDisplay: name,
    });
  };

  onChangeOptionProp = (propData, propArg) => {
    propData(propArg);
    this.setState({ listDisplay: false });
  };

  onBackList = () => {
    this.setState({
      listOptionDisplay: '',
    });
  };

  handleOnChangeAudio = (v) => {
    this.onChangeOptionProp(this.props.setAudioTrack, v);
  };

  handleOnChangeSubtitles = (v) => {
    this.onChangeOptionProp(this.props.setSubtitles, v);
  };

  handleOnChangeQuality = (v) => {
    this.onChangeOptionProp(this.props.setQuality, v);
  };

  handleClickAudio = () => {
    this.onChangeDisplayListOption('audio');
  };

  handleClickSubtitles = () => {
    this.onChangeDisplayListOption('subtitles');
  };

  handleClickQuality = () => {
    this.onChangeDisplayListOption('quality');
  };

  render() {
    const {
      audioTrackList,
      subtitlesList,
      qualityList,
      audioTrack,
      subtitles,
      quality,
      translate,
      isMobile,
    } = this.props;

    const {
      listDisplay,
      listOptionDisplay,
      audioOptions,
      qualityOptions,
      subtitlesOptions,
    } = this.state;

    return (
      <SettingsBarStyled>
        {listDisplay ? (
          <ListsWrap>
            <ListWrap>
              <List>
                {audioTrackList.length > 1 ? (
                  <SettingsList
                    dataRole="settingsAudio"
                    label={translate('embed.audiotrack')}
                    options={audioOptions}
                    current={audioTrack}
                    onChange={this.handleOnChangeAudio}
                    onClick={this.handleClickAudio}
                    onClose={this.onBackList}
                    onToggleList={this.onToggleDisplayList}
                    open={listOptionDisplay === 'audio'}
                    translate={translate}
                    isMobile={isMobile}
                  />
                ) : null}
                {subtitlesList.length > 1 ? (
                  <SettingsList
                    dataRole="settingsSubtitles"
                    label={translate('embed.subtitles')}
                    options={subtitlesOptions}
                    current={subtitles}
                    onChange={this.handleOnChangeSubtitles}
                    onClick={this.handleClickSubtitles}
                    onClose={this.onBackList}
                    onToggleList={this.onToggleDisplayList}
                    open={listOptionDisplay === 'subtitles'}
                    translate={translate}
                    isMobile={isMobile}
                  />
                ) : null}
                {qualityList.length > 1 ? (
                  <SettingsList
                    dataRole="settingsQuality"
                    label={translate('embed.quality')}
                    options={qualityOptions}
                    current={quality}
                    onChange={this.handleOnChangeQuality}
                    onClick={this.handleClickQuality}
                    onClose={this.onBackList}
                    onToggleList={this.onToggleDisplayList}
                    open={listOptionDisplay === 'quality'}
                    translate={translate}
                    isMobile={isMobile}
                  />
                ) : null}
              </List>
            </ListWrap>
          </ListsWrap>
        ) : null}
        <StyledButton
          icon={settingsSprite.id}
          iconSize={26}
          active={listDisplay}
          onClick={this.onToggleDisplayList}
          isMobile={isMobile}
        />
      </SettingsBarStyled>
    );
  }
}

SettingsBar.propTypes = {
  qualityList: PropTypes.array,
  audioTrackList: PropTypes.array,
  subtitlesList: PropTypes.array,
  setAudioTrack: PropTypes.func,
  setQuality: PropTypes.func,
  setSubtitles: PropTypes.func,
  translate: PropTypes.func,
  quality: PropTypes.number,
  audioTrack: PropTypes.number,
  subtitles: PropTypes.string,
  isMobile: PropTypes.bool,
  closePopup: PropTypes.func,
  getPopupState: PropTypes.func,
};

SettingsBar.defaultProps = {
  setAudioTrack: Function.prototype,
  setQuality: Function.prototype,
  setSubtitles: Function.prototype,
  translate: Function.prototype,
  audioTrackList: [],
  qualityList: [],
  subtitlesList: [],
  subtitles: 'off',
  audioTrack: 0,
  quality: -1,
  isMobile: false,
  closePopup: Function.prototype,
  getPopupState: Function.prototype,
};

export default SettingsBar;
